<form name="rppForm" id="rppForm" novalidate autocomplete="off">
  <div class="modal-header">
    <h3 class="modal-title"><strong>Delete Override</strong></h3>
    <div class="header-actions">
      <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         style="margin-right: 10px; cursor: pointer;" (click)="minimise = !minimise"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>
  <div class="modal-body" id="mainSection">
  </div>
  <div class="modal-footer">	
    @if (isDelete) {
<button 
            class="btn btn-info btn-sm" 
            type="button" 
            (click)="deletePayment()">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Delete
    </button>
}
    <button class="btn btn-warning btn-sm" 
            type="button" 
            (click)="cancel()">Cancel</button>
  </div>
</form>
